import { DeleteOutlined } from '@ant-design/icons'
import { Flex, Popconfirm } from 'antd'
import { PopconfirmProps } from 'antd/lib'

import { useLocales } from 'src/locales'

export const DeleteConfirm = (props: PopconfirmProps) => {
  const { t } = useLocales()

  return (
    <Popconfirm
      placement="leftBottom"
      description={t('common.delete_description')}
      {...props}
    >
      <Flex gap={8} onClick={(e) => e.stopPropagation()} className="full-width">
        <DeleteOutlined />
        {t('common.delete')}
      </Flex>
    </Popconfirm>
  )
}
